import React from 'react';

const NewsItem = ({ title, main_text, content, news_text, date, image }) => {
  const text = main_text || content || news_text || '';
  // Shorter preview if there's an image
  const previewLength = image ? 100 : 150;
  const preview = text.length > previewLength ? text.substring(0, previewLength) + '...' : text;
  
  // Format date
  const formattedDate = date ? new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }) : '';
  
  return (
    <div className="news-item">
      {image && (
        <div className="news-item-image">
          <img src={image} alt={title} />
        </div>
      )}
      <div className="news-item-content">
        {date && <div className="news-item-date">{formattedDate}</div>}
        <h4>{title || 'Untitled'}</h4>
        <p>{preview}</p>
        <div className="news-item-footer">
          <span className="read-more-link">Read more →</span>
        </div>
      </div>
    </div>
  );
}

export default NewsItem;
